import { withInstall } from '../utils'
import _Imguploader from './Imguploader'
import './index.scss'

export const Imguploader = withInstall(_Imguploader)
export default Imguploader
